// Candidate dashboard presentation; all counts, status codes and authored data stay intact.
const entries = {
  'candidate dashboard': ['painel do profissional','panel del profesional','candidate dashboard'],
  'follow your applications, responses and pending actions': ['acompanhe suas candidaturas, respostas e pendências','consulta tus candidaturas, respuestas y tareas pendientes','follow your applications, responses and pending actions'],
  'applications summary': ['resumo das candidaturas','resumen de candidaturas','applications summary'],
  'applications': ['candidaturas','candidaturas','applications'],
  'in progress': ['em andamento','en curso','in progress'],
  'accepted': ['aceitas','aceptadas','accepted'],
  'refused': ['rejeitadas','rechazadas','rejected'],
  'status applied': ['candidatura recebida','candidatura recibida','applied'],
  'status validating': ['em análise','en revisión','under review'],
  'status accepted': ['aceita','aceptada','accepted'],
  'status refused': ['rejeitada','rechazada','rejected'],
  'pending actions': ['pendências','tareas pendientes','pending actions'],
  'pending': ['pendente','pendiente','pending'],
  'pending plural': ['pendentes','pendientes','pending'],
  'you have no pending actions': ['você não tem pendências','no tienes tareas pendientes','you have no pending actions'],
  'respond to job invitation': ['responder ao convite para a vaga','responder a la invitación a la oferta','respond to job invitation'],
  'respond to interview': ['responder à entrevista','responder a la entrevista','respond to interview'],
  'my applications': ['minhas candidaturas','mis candidaturas','my applications'],
  'view all': ['ver todas','ver todas','view all'],
  'no applications found': ['nenhuma candidatura encontrada','no se encontraron candidaturas','no applications found'],
  'job title': ['título da vaga','título de la oferta','job title'],
  'company': ['empresa','empresa','company'],
  'status': ['situação','estado','status'],
  'last update': ['última atualização','última actualización','last update'],
  'recent responses': ['respostas recentes','respuestas recientes','recent responses'],
  'no responses yet': ['ainda não há respostas','todavía no hay respuestas','no responses yet'],
  'loading': ['carregando','cargando','loading'],
  'dashboard could not be loaded': ['não foi possível carregar o painel','no se pudo cargar el panel','the dashboard could not be loaded'],
  'try again': ['tentar novamente','volver a intentar','try again'],
  'no dashboard data': ['nenhum dado disponível para exibir no painel','no hay datos disponibles para mostrar en el panel','no dashboard data available'],
};
export default Object.fromEntries(['pt','es','en'].map((locale,index)=>[
  locale,Object.fromEntries(Object.entries(entries).map(([key,values])=>[`candidate dashboard ${key}`,values[index]])),
]));
